import { DelayShippingToggle } from '@apps/registry/admin/components/DelayShipping';
import { useTranslation } from '@shared/core';
import { ColumnsV2, Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';

export const DelayShippingSettings: React.FC = () => {
  const { t } = useTranslation('yourRegistry');
  const { delayShippingDescription } = t('delayShipping');
  return (
    <Flex
      backgroundColor="mono1"
      borderTop="1px solid mono3"
      borderBottom="1px solid mono3"
      paddingY={5}
      paddingX={7}
      flexDirection="column"
      marginBottom={7}
    >
      <DelayShippingToggle />
      <ColumnsV2>
        <ColumnsV2.Column span={9}>
          <TextV2>{delayShippingDescription()}</TextV2>
        </ColumnsV2.Column>
      </ColumnsV2>
    </Flex>
  );
};
